import { ModalContextProvider } from './ModalContext';
import Home from './pages/Home';

/* Theme variables */
import './theme/variables.css';

const App = () => (
	<ModalContextProvider>
		<Home />
	</ModalContextProvider>
);

export default App;
